export const GoogleMapApiConfig = 'AIzaSyDnG-SOuEUAqzFvse2UwAwqUFHtIfL-4SY';